// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { ManagementAPIOverigSpfControllerSpfStatus } from '../model/managementAPIOverigSpfControllerSpfStatus.ts';

import type { Result1OfSystemInt32 } from '../model/result1OfSystemInt32.ts';

import type { SpfCheckSpfRecordParams } from '../model/spfCheckSpfRecordParams.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Returns the spf status.
 */
export const spfCheckSpfRecord = (
  params?: MaybeRefOrGetter<SpfCheckSpfRecordParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<ManagementAPIOverigSpfControllerSpfStatus>(
    { url: `/api/v1/spf`, method: 'GET', params, signal },
    options,
  );
};

export const getSpfCheckSpfRecordQueryKey = (
  params?: MaybeRefOrGetter<SpfCheckSpfRecordParams>,
) => {
  return ['api', 'v1', 'spf', ...(params ? [params] : [])] as const;
};

export const getSpfCheckSpfRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof spfCheckSpfRecord>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<SpfCheckSpfRecordParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof spfCheckSpfRecord>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSpfCheckSpfRecordQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof spfCheckSpfRecord>>> = ({ signal }) =>
    spfCheckSpfRecord(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof spfCheckSpfRecord>>,
    TError,
    TData
  >;
};

export type SpfCheckSpfRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof spfCheckSpfRecord>>
>;
export type SpfCheckSpfRecordQueryError = ErrorType<unknown>;

/**
 * @summary Returns the spf status.
 */

export function useSpfCheckSpfRecord<
  TData = Awaited<ReturnType<typeof spfCheckSpfRecord>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<SpfCheckSpfRecordParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof spfCheckSpfRecord>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSpfCheckSpfRecordQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Haalt Spf status op voor de menu badge voor adviseur
 */
export const spfGetSpfMenuStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfSystemInt32>(
    { url: `/api/v1/spf/menu-status`, method: 'GET', signal },
    options,
  );
};

export const getSpfGetSpfMenuStatusQueryKey = () => {
  return ['api', 'v1', 'spf', 'menu-status'] as const;
};

export const getSpfGetSpfMenuStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof spfGetSpfMenuStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof spfGetSpfMenuStatus>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSpfGetSpfMenuStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof spfGetSpfMenuStatus>>> = ({ signal }) =>
    spfGetSpfMenuStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof spfGetSpfMenuStatus>>,
    TError,
    TData
  >;
};

export type SpfGetSpfMenuStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof spfGetSpfMenuStatus>>
>;
export type SpfGetSpfMenuStatusQueryError = ErrorType<unknown>;

/**
 * @summary Haalt Spf status op voor de menu badge voor adviseur
 */

export function useSpfGetSpfMenuStatus<
  TData = Awaited<ReturnType<typeof spfGetSpfMenuStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof spfGetSpfMenuStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSpfGetSpfMenuStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
